if (window && window.appConfig) {
    let isZarazExpEnabled = false;
    if (
        window.appConfig.LEAD_ZARAZ_KEY &&
        window.appConfig.lead_zaraz_is_enabled &&
        window.appConfig.lead_zaraz_distribution
    ) {
        /**
         * Check if the zaraz experiment is enabled
         * if it is - calculate the distribution here and activate the experiment accordingly.
         * (we're calculating it here because the cookies setup happens later on the flow)
         */
        isZarazExpEnabled =
            window.appConfig.lead_zaraz_is_enabled && Math.random() <= window.appConfig.lead_zaraz_distribution / 100;
    }
    if (isZarazExpEnabled) {
        // disable gtm pixel
        window.appConfig.LEAD_GTM_KEY = null;
    } else {
        // disable zaraz pixel
        window.appConfig.LEAD_ZARAZ_KEY = null;
    }
}
